const thumbnails = document.querySelectorAll('.video-thumbnail');
    const modal = document.getElementById('videoModal');
    const overlay = document.querySelector('.video-modal-overlay');
    const modalVideo = document.getElementById('modalVideo');
    const closeModal = document.getElementById('closeModal');
    const scrollMsg = document.getElementById('scrollMsg');
    const videos = Array.from(thumbnails).map(el => el.getAttribute('data-video'));
    let currentIndex = 0;
    let scrollShown = false;

    function playVideo(index) {
      if (index < 0) return;
      if (index >= videos.length) return closePlayer();

      currentIndex = index;
      modalVideo.src = videos[currentIndex];
      modal.style.display = 'block';
      overlay.style.display = 'block';
      modalVideo.play();
      scrollMsg.style.display = scrollShown ? 'none' : 'block';
      scrollShown = true;
    }

    function closePlayer() {
      modal.style.display = 'none';
      overlay.style.display = 'none';
      modalVideo.pause();
      modalVideo.src = '';
      scrollMsg.style.display = 'none';
    }

    thumbnails.forEach((thumbnail, i) => {
      thumbnail.addEventListener('click', () => playVideo(i));
    });

    closeModal.addEventListener('click', closePlayer);
    overlay.addEventListener('click', closePlayer);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') return closePlayer();
      if (modal.style.display !== 'block') return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') return playVideo(currentIndex + 1);
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') return playVideo(currentIndex - 1);
    });

    modalVideo.addEventListener('ended', () => playVideo(currentIndex + 1));

    let startY = 0, startX = 0;
    modalVideo.addEventListener('touchstart', e => {
      startY = e.changedTouches[0].clientY;
      startX = e.changedTouches[0].clientX;
    });

    modalVideo.addEventListener('touchend', e => {
      const endY = e.changedTouches[0].clientY;
      const endX = e.changedTouches[0].clientX;
      const deltaY = endY - startY;
      const deltaX = endX - startX;

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        if (deltaY < -30) playVideo(currentIndex + 1);
        else if (deltaY > 30) playVideo(currentIndex - 1);
      } else {
        if (deltaX < -30) playVideo(currentIndex + 1);
        else if (deltaX > 30) playVideo(currentIndex - 1);
      }
    }, { passive: true });

    modalVideo.addEventListener('wheel', e => {
      if (modal.style.display !== 'block') return;
      e.preventDefault();
      if (e.deltaY > 20) playVideo(currentIndex + 1);
      else if (e.deltaY < -20) playVideo(currentIndex - 1);
    }, { passive: false });